import React from "react";

export const TextArea = ({ label, errorMessage, error, ...rest }) => {
  return (
    <div className="flex w-full flex-col items-start my-3">
      {/* <div> */}
      {/* // className="flex w-full flex-1 px-3 py-2.5 border rounded-lg
        border-blue-100 hover:border-textGray focus-within:border-textGray
        relative group"> */}
      <textarea
        className="flex resize-none w-full flex-1 px-3 py-2.5 border rounded-lg border-blue-100 hover:border-textGray focus:border-textGray focus: outline-none relative group"
        //  className="border-none outline-none focus:placeholder:invisible flex flex-1"
        placeholder={label}
        {...rest}
      />
      {/* </div> */}
      {!!error && (
        <div className="text-sm text-red-500 pl-1">{errorMessage}</div>
      )}
    </div>
  );
};
